var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 42,
    viewBox: "0 0 54 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.1379 0H1.86207C0.833677 0 0 0.832037 0 1.85841V11.1504C0 12.1768 0.833677 13.0089 1.86207 13.0089H52.1379C53.1663 13.0089 54 12.1768 54 11.1504V1.85841C54 0.832037 53.1663 0 52.1379 0Z",
    fill: "#EAEAEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6413 2.97363H5.95855C5.34151 2.97363 4.84131 3.47286 4.84131 4.08868C4.84131 4.7045 5.34151 5.20372 5.95855 5.20372H15.6413C16.2583 5.20372 16.7585 4.7045 16.7585 4.08868C16.7585 3.47286 16.2583 2.97363 15.6413 2.97363Z",
    fill: "#71717A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3448 7.80566H5.95855C5.34151 7.80566 4.84131 8.30489 4.84131 8.92071C4.84131 9.53653 5.34151 10.0358 5.95855 10.0358H22.3448C22.9618 10.0358 23.462 9.53653 23.462 8.92071C23.462 8.30489 22.9618 7.80566 22.3448 7.80566Z",
    fill: "#A1A1AA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1379 14.4956H1.86207C0.833677 14.4956 0 15.3276 0 16.354V25.646C0 26.6724 0.833677 27.5045 1.86207 27.5045H52.1379C53.1663 27.5045 54 26.6724 54 25.646V16.354C54 15.3276 53.1663 14.4956 52.1379 14.4956Z",
    fill: "#EAEAEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6413 17.4692H5.95855C5.34151 17.4692 4.84131 17.9685 4.84131 18.5843C4.84131 19.2001 5.34151 19.6993 5.95855 19.6993H15.6413C16.2583 19.6993 16.7585 19.2001 16.7585 18.5843C16.7585 17.9685 16.2583 17.4692 15.6413 17.4692Z",
    fill: "#71717A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3448 22.3013H5.95855C5.34151 22.3013 4.84131 22.8005 4.84131 23.4163C4.84131 24.0321 5.34151 24.5314 5.95855 24.5314H22.3448C22.9618 24.5314 23.462 24.0321 23.462 23.4163C23.462 22.8005 22.9618 22.3013 22.3448 22.3013Z",
    fill: "#A1A1AA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1379 28.9912H1.86207C0.833677 28.9912 0 29.8232 0 30.8496V40.1417C0 41.168 0.833677 42.0001 1.86207 42.0001H52.1379C53.1663 42.0001 54 41.168 54 40.1417V30.8496C54 29.8232 53.1663 28.9912 52.1379 28.9912Z",
    fill: "#EAEAEC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6413 31.9648H5.95855C5.34151 31.9648 4.84131 32.4641 4.84131 33.0799C4.84131 33.6957 5.34151 34.1949 5.95855 34.1949H15.6413C16.2583 34.1949 16.7585 33.6957 16.7585 33.0799C16.7585 32.4641 16.2583 31.9648 15.6413 31.9648Z",
    fill: "#71717A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3448 36.7969H5.95855C5.34151 36.7969 4.84131 37.2961 4.84131 37.9119C4.84131 38.5277 5.34151 39.027 5.95855 39.027H22.3448C22.9618 39.027 23.462 38.5277 23.462 37.9119C23.462 37.2961 22.9618 36.7969 22.3448 36.7969Z",
    fill: "#A1A1AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuest);
export default __webpack_public_path__ + "static/media/guest.0d5258c3f09385d3da455dc95a65bb6c.svg";
export { ForwardRef as ReactComponent };